import { render, staticRenderFns } from "./ViewProjectModal.vue?vue&type=template&id=646c0200&"
import script from "./ViewProjectModal.vue?vue&type=script&lang=js&"
export * from "./ViewProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports